export class MenuOption {
  public nameMe: string;
  public nameEn: string;
  public colorCode: string;
  public link?: string;
  public subOptions?: Array<MenuOption>;
  public isHovered?: boolean = false;
  public target?: string;
}
